// Shared icon lookup for achievement.iconName / award.icon — both come from
// admin-curated slugs. Union of every case referenced across PostCard,
// FeedPage, ExplorerProfilePage and AchievementsPage.

import React from "react";
import {
  Award,
  CalendarDays,
  Clock,
  Cloud,
  Compass,
  CloudRain,
  Crown,
  Flag,
  Footprints,
  Gem,
  Gift,
  Globe2,
  Landmark,
  Lock,
  Map,
  Moon,
  MountainSnow,
  Route,
  Star,
  Sun,
  Sunrise,
  Triangle,
  Trophy,
  Zap,
} from "lucide-react";

export function iconByName(name: string | null | undefined, size: number): React.ReactNode {
  const p = { size };
  switch (name) {
    case "mountain": return <MountainSnow {...p} />;
    case "flag": return <Flag {...p} />;
    case "route": return <Route {...p} />;
    case "footprints": return <Footprints {...p} />;
    case "sunrise": return <Sunrise {...p} />;
    case "triangle": return <Triangle {...p} />;
    case "award": return <Award {...p} />;
    case "cloud-rain": return <CloudRain {...p} />;
    case "moon": return <Moon {...p} />;
    case "globe": return <Globe2 {...p} />;
    case "compass": return <Compass {...p} />;
    case "star": return <Star {...p} />;
    case "lock": return <Lock {...p} />;
    case "landmark": return <Landmark {...p} />;
    case "gift": return <Gift {...p} />;
    case "map": return <Map {...p} />;
    case "cloud": return <Cloud {...p} />;
    case "calendar": return <CalendarDays {...p} />;
    case "clock": return <Clock {...p} />;
    case "sun": return <Sun {...p} />;
    case "zap": return <Zap {...p} />;
    case "crown": return <Crown {...p} />;
    case "gem": return <Gem {...p} />;
    default: return <Trophy {...p} />;
  }
}
